const func = $target => {
	var $plans = $target.find('[data-toggle="modal"]'),
		$modal = $($plans.eq(1).attr('data-target'));

	$modal.on('show.bs.modal', function(e) {
		var $button = $(e.relatedTarget),
			uid = $button.data('plan-uid'),
			name = $button.data('plan-name');

		$modal.find('input[name="planUid"]').val(uid);
		$modal.find('span[data-id="planName"]').text(name);
	});
};

export default func;
